import AbstractController from '../src/services/ControllersRepository/AbstractController';
import PaymentTypeUpdateForm from '@views/payment-types/PaymentTypeUpdateForm';
import PaymentTypeCreateForm from '@views/payment-types/PaymentTypeCreateForm';

export default class PaymentTypes extends AbstractController {
    protected controllerName = 'PaymentTypes';

    protected getDefaultCreateFormComponent() {
        return PaymentTypeCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return PaymentTypeUpdateForm;
    }
}
